import React from 'react'
import { Modal } from 'antd'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { deleteSite } from 'action/site'
import { DELETE_SITE_STATUS } from 'common/constant/delete-site-status'
import * as MODAL from 'constant/modal'
import * as NUMBER from 'constant/number'
import PropTypes from 'prop-types'

const FALLBACK_ERROR = 'Please try again'
const REMOVE_USERS_OK_TEXT = 'Remove users and delete site'
const USERS_LIST_STYLE = { margin: 0, maxHeight: '240px', overflowY: 'auto', paddingLeft: '20px' }

const showOutcome = (type, title, content) =>
  Modal[type]({ centered: true, content, okText: MODAL.OUTCOME.OK_TEXT, title })

const fullName = ({ first_name: first, last_name: last, email }) =>
  [first, last].filter(Boolean).join(' ') || email

const usersHeading = (users, name) => users.length === NUMBER.ONE
  ? `1 user has access to ${name}`
  : `${users.length} users have access to ${name}`

const UsersList = ({ users, name }) => (
  <>
    <p>Deleting {name} removes their access to it. Their accounts are kept.</p>
    <ul style={USERS_LIST_STYLE}>
      {users.map((user) => (
        <li key={user.uuid}>{fullName(user)} ({user.email}){user.role ? `, ${user.role}` : ''}</li>
      ))}
    </ul>
  </>
)

UsersList.propTypes = {
  name: PropTypes.string,
  users: PropTypes.array
}

const DeleteSite = ({ deleteSite, site: { uuid, site_name: name } }) => {
  // The first request for a site with users deletes nothing and gets their list
  // back. The admin confirms them in a second modal and the request is sent again
  // with their ids. If the users changed in between, the list comes back again.
  const attempt = async (confirmedUsers) => {
    const response = await deleteSite(uuid, confirmedUsers)

    if (response?.error) {
      return showOutcome('error', `There has been an issue deleting ${name}`, response.message || FALLBACK_ERROR)
    }

    if (response?.status === DELETE_SITE_STATUS.CONFIRM_USERS) {
      return confirmUsers(response.users)
    }

    return showOutcome('success', 'Site deleted', `${name} has been successfully deleted.`)
  }

  const confirmUsers = (users) => Modal.confirm({
    cancelText: MODAL.DECIDE.CANCEL_TEXT,
    centered: true,
    content: <UsersList name={name} users={users} />,
    okText: REMOVE_USERS_OK_TEXT,
    onOk: () => attempt(users.map(({ uuid }) => uuid)),
    title: usersHeading(users, name)
  })

  const handleClick = () => Modal.confirm({
    cancelText: MODAL.DECIDE.CANCEL_TEXT,
    centered: true,
    content: 'This action cannot be undone',
    okText: MODAL.DECIDE.OK_TEXT,
    onOk: () => attempt(),
    title: `Are you sure you want to delete ${name}?`
  })

  return <a onClick={handleClick}>Delete Site</a>
}

DeleteSite.propTypes = {
  deleteSite: PropTypes.func,
  site: PropTypes.object
}

const mapDispatchToProps = (dispatch) => ({
  deleteSite: bindActionCreators(deleteSite, dispatch)
})

export default connect(null, mapDispatchToProps)(DeleteSite)
